/**
 * Key of an entry draft inside `entryDrafts[activeProfileId]`.
 *
 * Drafts of new entries all have id '0', so a new community entry is keyed by
 * the community id as well, to keep drafts of different communities apart.
 */
export function getEntryDraftKey(entryId, blog) {
  if (blog.isCommunity && entryId === '0') {
    return `${blog.id}.${entryId}`;
  }

  return entryId;
}
